import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { urlHome, urlApi } from "../constants";
import { arrowLeft, logo, otp } from "../assets";

const Verify = () => {
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(false);
  const [email, setEmail] = useState("");
  const { token } = useParams();
  useEffect(() => {
    if (token !== null) {
      fetch(urlApi + "/v1/auth/email/confirm/" + token, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.message == "SUCCESS") {
            setVerified(true);
            setLoading(false);
            setEmail(data.data.email);
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);
  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-scroll justify-center">
      <div className="absolute top-5 left-5">
        <Link
          className="flex flex-row border text-primary border-primary rounded-md px-3 py-1 justify-center hover:bg-quaternary  hover:fill-primary"
          to={urlHome}
        >
          <img src={arrowLeft} alt="back" className="w-[14px]" />
          <p className="ml-4 text-[14px] md:text-[16px]">Home</p>
        </Link>
      </div>
      <div className="flex flex-col bg-white justify-center items-center">
        <img src={logo} className="w-[40%] sm:max-w-[200px] mb-8" />
        <div className="flex flex-col border text-black justify-center items-center shadow-lg rounded-lg font-rubik w-[70%] sm:max-w-[400px]">
          <div className="flex flex-col w-[90%] py-3">
            {loading ? (
              <div role="status">
                <svg
                  aria-hidden="true"
                  className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-secondary"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="white"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="#E47410"
                  />
                </svg>
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              <div className="divide-y">
                <div className="mb-2">
                  <div className="flex flex-row items-center">
                    <div className="font-black text-black text-[17px] md:text-[24px]">
                      {verified
                        ? "Your Email Verified!"
                        : "Link Broken or Expired!"}
                    </div>
                  </div>
                  {verified ? (
                    <p className="text-[12px] md:text-[14px] font-thin text-gray-500 my-3">
                      Thanks{" "}
                      <span className="font-bold text-black">{email}</span>
                      for register to nitomeyo. <br />
                      <br />
                      Now you can make seamless virtual card experience to
                      enhance your impression.
                    </p>
                  ) : (
                    <p className="text-[12px] md:text-[14px] font-thin text-gray-500 my-3">
                      We are sorry we cannot understand your request. Either the
                      link is broken or expired.
                    </p>
                  )}
                </div>
                <form className="flex flex-col justify-center space-y-3">
                  <div className="flex flex-row mt-5 py-2">
                    <Link
                      to="/login"
                      className="text-white py-2 px-2 bg-primary hover:bg-tertiary rounded-md w-full justify-center items-center flex flex-col"
                    >
                      <p className="font-base tracking-wider text-[14px] md:text-[16px]">
                        Back to Login
                      </p>
                    </Link>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verify;
